// extracted by mini-css-extract-plugin
export default {"menuTitle":"BaseOverlayMenuListTitle_menuTitle_kzTT6"};